import { Skeleton } from '@/ui/components/common/Skeleton'

/**
 * Loading-state placeholder shaped like an investigation tile, used while
 * the list query is still pending.
 */
export function TileSkeleton() {
  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden flex h-32">
      <Skeleton className="w-36 sm:w-52 shrink-0" />
      <div className="flex-1 p-5 space-y-2">
        <Skeleton className="h-4 w-1/3" />
        <Skeleton className="h-5 w-2/3" />
        <Skeleton className="h-4 w-full" />
      </div>
    </div>
  )
}
